import { render, staticRenderFns } from "./HardwareCapabilities.vue?vue&type=template&id=4a075a83"
import script from "./HardwareCapabilities.vue?vue&type=script&lang=js"
export * from "./HardwareCapabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports